import { render, staticRenderFns } from "./view-item.vue?vue&type=template&id=54561631&scoped=true"
import script from "./view-item.vue?vue&type=script&lang=js"
export * from "./view-item.vue?vue&type=script&lang=js"
import style0 from "./view-item.vue?vue&type=style&index=0&id=54561631&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54561631",
  null
  
)

export default component.exports